import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.less';

const AdmissionEnNonValeurComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group className="panelRow">
          <Form.Input
            name="exerRattachement"
            label="Année de constitution de la liste"
            value={data?.exerRattachement}
            title={data?.exerRattachement}
            onChange={handleChange}
            width={8}
            input={{
              maxLength: 4,
            }}
          />
          <Form.Input
            name="pieceOrigine"
            label="Numéro de la liste de non valeur"
            value={data?.pieceOrigine}
            title={data?.pieceOrigine}
            onChange={handleChange}
            width={8}
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default AdmissionEnNonValeurComponent;
